import React from "react";
import Layout from "@/components/Layout";
import Breadcrumbs from "@/components/Breadcrumbs";
import JsonLd from "@/components/JsonLd";
import usePageMeta from "@/hooks/use-page-meta";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { FAQS, BRAND } from "@/constants/content";

export default function FAQsPage() {
  usePageMeta({
    title: "FAQs — Home Healthcare in Delhi NCR | KinFlex",
    description: "Frequently asked questions about home nursing, ICU setup, elder care, physiotherapy and medical equipment rental with KinFlex.",
    canonical: `https://${BRAND.domain}/faqs`,
  });

  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: FAQS.map((f) => ({
      "@type": "Question",
      name: f.q,
      acceptedAnswer: { "@type": "Answer", text: f.a },
    })),
  };

  return (
    <Layout>
      <JsonLd data={jsonLd} />
      <section className="pt-28 pb-6 md:pt-36 md:pb-12 bg-hero-gradient relative overflow-hidden">
        <div className="absolute inset-0 bg-medical-grid opacity-60 pointer-events-none" />
        <div className="container-page relative max-w-4xl">
          <Breadcrumbs items={[{ label: "FAQs" }]} />
          <div className="mt-5 eyebrow">Frequently Asked Questions</div>
          <h1 className="mt-2 font-display font-bold text-slate-900 text-4xl md:text-5xl lg:text-6xl tracking-tight leading-[1.05]">
            Everything families ask us <span className="bg-gradient-to-r from-[#0A84FF] to-[#10B981] bg-clip-text text-transparent">before booking</span>.
          </h1>
        </div>
      </section>

      <section className="py-12 md:py-16 bg-white">
        <div className="container-page max-w-3xl">
          <Accordion type="single" collapsible className="space-y-3" data-testid="faqs-page-accordion">
            {FAQS.map((f, i) => (
              <AccordionItem key={i} value={`fq-${i}`} className="border border-slate-200 rounded-2xl bg-white data-[state=open]:border-[#0A84FF]/40 data-[state=open]:shadow-md px-5">
                <AccordionTrigger className="text-left font-display font-semibold text-slate-900 hover:no-underline py-5">{f.q}</AccordionTrigger>
                <AccordionContent className="text-slate-600 leading-relaxed pb-5">{f.a}</AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </section>
    </Layout>
  );
}
